import { render, staticRenderFns } from "./search_item.vue?vue&type=template&id=6b0ad45d"
import script from "./search_item.vue?vue&type=script&lang=js"
export * from "./search_item.vue?vue&type=script&lang=js"
import style0 from "./search_item.vue?vue&type=style&index=0&id=6b0ad45d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports